import { withInstall } from '@vuemap/vue-amap-util'
import Geolocation from './Geolocation.vue'

export const ElAmapControlGeolocation = withInstall(Geolocation)
export default ElAmapControlGeolocation
